/* eslint-disable no-param-reassign,no-restricted-globals */
import store from '../store';

export default {
  helpers: {
    $isAdmin() {
      if (store.state.users.current) {
        return store.state.users.current.role === 'admin';
      }
      return false;
    },

    $isCurrentUser(id) {
      if (store.state.users.current) {
        return store.state.users.current.id === id;
      }
      return false;
    },

    $formatDate(date) {
      if (date) {
        const d = new Date(date);
        if (d instanceof Date && !isNaN(d)) {
          let [year, month, day] = date.split('-');
          if (!year) {
            year = '2010';
          }
          if (!month) {
            month = '01';
          }
          if (!day) {
            day = '01';
          }
          return `${year}-${month}-${day}`;
        }
        return null;
      }
      return null;
    },

    $openFile(file, nameField) {
      if (!file.url) {
        return;
      }
      let fileName;
      if (nameField) {
        fileName = nameField;
      } else {
        fileName = 'file_name';
      }
      this.$http({
        url: file.url,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const fileURL = URL.createObjectURL(response.data);
        const windowRef = window.open(fileURL, file[fileName]);
        setTimeout(() => {
          if (!windowRef || (windowRef && !windowRef.self)) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file[fileName]);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          }
        }, 500);
      });
    },
  },

  registerHelpers(Vue) {
    Object.keys(this.helpers).forEach((helper) => {
      Vue.prototype[helper] = this.helpers[helper];
    });
  },
};
